import { useStyles, Container } from '@archipro-design/aria';
import type { ReactNode } from 'react';
import * as S from './PageLayout.style';

interface PageLayoutProps {
    children: ReactNode;
}

const PageLayout = ({ children }: PageLayoutProps) => {
    const { css } = useStyles();
    return (
        <div className={css(S.Page)}>
            <Container className={css(S.Container)}>{children}</Container>
        </div>
    );
};

export default PageLayout;
